// Module
var code = `<ul class="script-content-tabs-holder"></ul>
<ul class="script-content-views-holder"></ul>
`;
// Exports
module.exports = code;